/** Paramètres → Paiements : auto, échéances, type, devis, e-mails. */
import { useEffect, useState } from "react";
import { facturxFetch } from "../../api/client";
import { Button } from "../../components/Button";
import { useCompany } from "../../company/CompanyProvider";
import { paymentsFromCompany, type CompanyPayments, type PaymentTerm } from "../../payments/types";
import { PaymentsAuto } from "./PaymentsRhythm";
import { PaymentsGateways } from "./PaymentsGateways";
import { PaymentsMail } from "./PaymentsMail";
import { isCompanyOwner } from "./owner";
import { PaymentsPolicy } from "./PaymentsPolicy";

export function PaymentsTab() {
  const { company, updatePayments } = useCompany();
  const [draft, setDraft] = useState<CompanyPayments | null>(null);
  const [terms, setTerms] = useState<PaymentTerm[]>([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!company) return;
    setDraft(paymentsFromCompany(company));
    setMsg("");
    setErr("");
    facturxFetch<{ payment_terms: PaymentTerm[] }>(`lookups.php?company_id=${company.id}`)
      .then((data) => {
        setTerms(
          (data.payment_terms || []).map((t) => ({
            ...t,
            id: Number(t.id),
            days: Number(t.days),
          }))
        );
      })
      .catch((e) => setErr(e instanceof Error ? e.message : "Échéances indisponibles"));
    facturxFetch<{ auto_bill_at?: string; gc_charge_at?: string }>(`payment-clock.php?company_id=${company.id}`)
      .then((clock) => {
        setDraft((prev) =>
          prev
            ? {
                ...prev,
                auto_bill_at: clock.auto_bill_at || prev.auto_bill_at,
                gc_charge_at: clock.gc_charge_at || prev.gc_charge_at,
              }
            : prev
        );
      })
      .catch(() => {
        /* défauts 06:15 / 06:30 */
      });
  }, [company]);

  if (!company || !draft) {
    return <p className="text-sm" style={{ color: "var(--fx-muted)" }}>Aucune société.</p>;
  }

  const companyId = company.id;
  const owner = isCompanyOwner(company);

  async function save() {
    if (!draft) return;
    setBusy(true);
    setErr("");
    setMsg("");
    try {
      await updatePayments(companyId, draft);
      await facturxFetch("payment-clock.php", {
        method: "PATCH",
        body: JSON.stringify({
          company_id: companyId,
          auto_bill_at: draft.auto_bill_at,
          gc_charge_at: draft.gc_charge_at,
        }),
      });
      setMsg("Enregistré.");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fx-pay">
      <div className="fx-co-card">
        <header className="fx-co-card__head">
          <h2>Paiements</h2>
          <p>Réglages globaux : auto, échéance par défaut, type, devis, e-mails.</p>
          {!owner ? (
            <p className="fx-co-form__hint">Lecture seule — seul le propriétaire enregistre les paiements.</p>
          ) : null}
        </header>
        <div className="fx-fmt">
          <PaymentsAuto draft={draft} setDraft={setDraft} />
          <PaymentsPolicy draft={draft} setDraft={setDraft} terms={terms} />
          <PaymentsMail draft={draft} setDraft={setDraft} />
        </div>
        {err ? <p className="fx-co-form__err">{err}</p> : null}
        {msg ? <p className="fx-co-form__ok">{msg}</p> : null}
        <div className="fx-co-card__foot">
          <Button disabled={busy || !owner} onClick={() => void save()}>
            Enregistrer
          </Button>
        </div>
      </div>
      <PaymentsGateways />
    </div>
  );
}
